package ru.villawonka.app.domain.model

enum class LanguageDomain {
    EN,
    RU,
}